import { defineStore } from "pinia";
import { ref } from "vue";
import type {
    ProductSearchAggregations
} from "@/api/modules/autoQ/productSearch/searchResultTypes";
import type {
    ElasticSearchAggregation
} from "@/types";

export const useProductSearchFilterOptionsStore = defineStore("productSearchFilterOptionsStore", () => {
    const elasticSearchAggregations = ref<ProductSearchAggregations | undefined>();

    const setFilterOptions = (options: ProductSearchAggregations) => {
        elasticSearchAggregations.value = options;
    };

    const getFilterOption = (propertyName: string): null | ElasticSearchAggregation => {
        if (!elasticSearchAggregations.value) return null;

        return elasticSearchAggregations.value[propertyName] as ElasticSearchAggregation;
    };

    return {
        setFilterOptions,
        filterOptions: elasticSearchAggregations,
        getFilterOption
    };
});